/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PrototypeRouteImport } from './routes/prototype'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as PrototypeIndexRouteImport } from './routes/prototype.index'
import { Route as AuthIndexRouteImport } from './routes/_auth.index'
import { Route as AuthResetRouteImport } from './routes/auth.reset'
import { Route as AuthInviteRouteImport } from './routes/auth.invite'
import { Route as AuthForgotRouteImport } from './routes/auth.forgot'
import { Route as AuthChangePasswordRouteImport } from './routes/auth.change-password'
import { Route as AuthNoAccessRouteImport } from './routes/_auth.no-access'
import { Route as PrototypeCCompanyIdRouteImport } from './routes/prototype.c.$companyId'
import { Route as AuthCCompanyIdRouteImport } from './routes/_auth.c.$companyId'
import { Route as PrototypeCCompanyIdIndexRouteImport } from './routes/prototype.c.$companyId.index'
import { Route as AuthCCompanyIdIndexRouteImport } from './routes/_auth.c.$companyId.index'
import { Route as PrototypeCCompanyIdReviewRouteImport } from './routes/prototype.c.$companyId.review'
import { Route as PrototypeCCompanyIdHomeRouteImport } from './routes/prototype.c.$companyId.home'
import { Route as PrototypeCCompanyIdSplatRouteImport } from './routes/prototype.c.$companyId.$'
import { Route as AuthCCompanyIdSetupRouteImport } from './routes/_auth.c.$companyId.setup'
import { Route as AuthCCompanyIdReviewRouteImport } from './routes/_auth.c.$companyId.review'
import { Route as PrototypeCCompanyIdJournalsIndexRouteImport } from './routes/prototype.c.$companyId.journals.index'
import { Route as PrototypeCCompanyIdInboxIndexRouteImport } from './routes/prototype.c.$companyId.inbox.index'
import { Route as PrototypeCCompanyIdBankingIndexRouteImport } from './routes/prototype.c.$companyId.banking.index'
import { Route as AuthCCompanyIdJournalsIndexRouteImport } from './routes/_auth.c.$companyId.journals.index'
import { Route as AuthCCompanyIdBankingIndexRouteImport } from './routes/_auth.c.$companyId.banking.index'
import { Route as PrototypeCCompanyIdReportsTrialBalanceRouteImport } from './routes/prototype.c.$companyId.reports.trial-balance'
import { Route as PrototypeCCompanyIdReportsLedgerRouteImport } from './routes/prototype.c.$companyId.reports.ledger'
import { Route as PrototypeCCompanyIdJournalsNewRouteImport } from './routes/prototype.c.$companyId.journals.new'
import { Route as PrototypeCCompanyIdJournalsEntryIdRouteImport } from './routes/prototype.c.$companyId.journals.$entryId'
import { Route as PrototypeCCompanyIdInboxItemIdRouteImport } from './routes/prototype.c.$companyId.inbox.$itemId'
import { Route as AuthCCompanyIdSettingsUsersRouteImport } from './routes/_auth.c.$companyId.settings.users'
import { Route as AuthCCompanyIdSettingsPeriodsRouteImport } from './routes/_auth.c.$companyId.settings.periods'
import { Route as AuthCCompanyIdSettingsFxRatesRouteImport } from './routes/_auth.c.$companyId.settings.fx-rates'
import { Route as AuthCCompanyIdSettingsDefaultAccountsRouteImport } from './routes/_auth.c.$companyId.settings.default-accounts'
import { Route as AuthCCompanyIdSettingsCostCentresRouteImport } from './routes/_auth.c.$companyId.settings.cost-centres'
import { Route as AuthCCompanyIdSettingsChartRouteImport } from './routes/_auth.c.$companyId.settings.chart'
import { Route as AuthCCompanyIdSettingsApprovalsRouteImport } from './routes/_auth.c.$companyId.settings.approvals'
import { Route as AuthCCompanyIdReportsTrialBalanceRouteImport } from './routes/_auth.c.$companyId.reports.trial-balance'
import { Route as AuthCCompanyIdReportsOpenItemsRouteImport } from './routes/_auth.c.$companyId.reports.open-items'
import { Route as AuthCCompanyIdReportsLedgerRouteImport } from './routes/_auth.c.$companyId.reports.ledger'
import { Route as AuthCCompanyIdJournalsStockCountRouteImport } from './routes/_auth.c.$companyId.journals.stock-count'
import { Route as AuthCCompanyIdJournalsNewRouteImport } from './routes/_auth.c.$companyId.journals.new'
import { Route as AuthCCompanyIdJournalsDraftIdRouteImport } from './routes/_auth.c.$companyId.journals.$draftId'
import { Route as AuthCCompanyIdEntriesEntryIdRouteImport } from './routes/_auth.c.$companyId.entries.$entryId'
import { Route as PrototypeCCompanyIdSalesInvoicesIndexRouteImport } from './routes/prototype.c.$companyId.sales.invoices.index'
import { Route as PrototypeCCompanyIdPurchasesPaymentsIndexRouteImport } from './routes/prototype.c.$companyId.purchases.payments.index'
import { Route as PrototypeCCompanyIdPurchasesBillsIndexRouteImport } from './routes/prototype.c.$companyId.purchases.bills.index'
import { Route as AuthCCompanyIdPurchasesSuppliersIndexRouteImport } from './routes/_auth.c.$companyId.purchases.suppliers.index'
import { Route as AuthCCompanyIdPurchasesPaymentsIndexRouteImport } from './routes/_auth.c.$companyId.purchases.payments.index'
import { Route as AuthCCompanyIdPurchasesCreditsIndexRouteImport } from './routes/_auth.c.$companyId.purchases.credits.index'
import { Route as AuthCCompanyIdPurchasesBillsIndexRouteImport } from './routes/_auth.c.$companyId.purchases.bills.index'
import { Route as AuthCCompanyIdBankingMovementsIndexRouteImport } from './routes/_auth.c.$companyId.banking.movements.index'
import { Route as PrototypeCCompanyIdSalesInvoicesNewRouteImport } from './routes/prototype.c.$companyId.sales.invoices.new'
import { Route as PrototypeCCompanyIdSalesInvoicesInvoiceIdRouteImport } from './routes/prototype.c.$companyId.sales.invoices.$invoiceId'
import { Route as PrototypeCCompanyIdPurchasesPaymentsNewRouteImport } from './routes/prototype.c.$companyId.purchases.payments.new'
import { Route as PrototypeCCompanyIdPurchasesPaymentsPaymentIdRouteImport } from './routes/prototype.c.$companyId.purchases.payments.$paymentId'
import { Route as PrototypeCCompanyIdPurchasesBillsNewRouteImport } from './routes/prototype.c.$companyId.purchases.bills.new'
import { Route as PrototypeCCompanyIdPurchasesBillsBillIdRouteImport } from './routes/prototype.c.$companyId.purchases.bills.$billId'
import { Route as PrototypeCCompanyIdBankingEasyEntriesNewRouteImport } from './routes/prototype.c.$companyId.banking.easy-entries.new'
import { Route as PrototypeCCompanyIdBankingAccountIdReconcileRouteImport } from './routes/prototype.c.$companyId.banking.$accountId.reconcile'
import { Route as AuthCCompanyIdPurchasesSuppliersContactIdRouteImport } from './routes/_auth.c.$companyId.purchases.suppliers.$contactId'
import { Route as AuthCCompanyIdPurchasesPaymentsNewRouteImport } from './routes/_auth.c.$companyId.purchases.payments.new'
import { Route as AuthCCompanyIdPurchasesPaymentsPaymentIdRouteImport } from './routes/_auth.c.$companyId.purchases.payments.$paymentId'
import { Route as AuthCCompanyIdPurchasesCreditsNewRouteImport } from './routes/_auth.c.$companyId.purchases.credits.new'
import { Route as AuthCCompanyIdPurchasesCreditsCreditIdRouteImport } from './routes/_auth.c.$companyId.purchases.credits.$creditId'
import { Route as AuthCCompanyIdPurchasesBillsNewRouteImport } from './routes/_auth.c.$companyId.purchases.bills.new'
import { Route as AuthCCompanyIdPurchasesBillsBillIdRouteImport } from './routes/_auth.c.$companyId.purchases.bills.$billId'
import { Route as AuthCCompanyIdBankingMovementsNewRouteImport } from './routes/_auth.c.$companyId.banking.movements.new'
import { Route as AuthCCompanyIdBankingMovementsMovementIdRouteImport } from './routes/_auth.c.$companyId.banking.movements.$movementId'

const PrototypeRoute = PrototypeRouteImport.update({
  id: '/prototype',
  path: '/prototype',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const PrototypeIndexRoute = PrototypeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PrototypeRoute,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetRoute = AuthResetRouteImport.update({
  id: '/auth/reset',
  path: '/auth/reset',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthInviteRoute = AuthInviteRouteImport.update({
  id: '/auth/invite',
  path: '/auth/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthForgotRoute = AuthForgotRouteImport.update({
  id: '/auth/forgot',
  path: '/auth/forgot',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthChangePasswordRoute = AuthChangePasswordRouteImport.update({
  id: '/auth/change-password',
  path: '/auth/change-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthNoAccessRoute = AuthNoAccessRouteImport.update({
  id: '/no-access',
  path: '/no-access',
  getParentRoute: () => AuthRoute,
} as any)
const PrototypeCCompanyIdRoute = PrototypeCCompanyIdRouteImport.update({
  id: '/c/$companyId',
  path: '/c/$companyId',
  getParentRoute: () => PrototypeRoute,
} as any)
const AuthCCompanyIdRoute = AuthCCompanyIdRouteImport.update({
  id: '/c/$companyId',
  path: '/c/$companyId',
  getParentRoute: () => AuthRoute,
} as any)
const PrototypeCCompanyIdIndexRoute =
  PrototypeCCompanyIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrototypeCCompanyIdRoute,
  } as any)
const AuthCCompanyIdIndexRoute = AuthCCompanyIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthCCompanyIdRoute,
} as any)
const PrototypeCCompanyIdReviewRoute =
  PrototypeCCompanyIdReviewRouteImport.update({
    id: '/review',
    path: '/review',
    getParentRoute: () => PrototypeCCompanyIdRoute,
  } as any)
const PrototypeCCompanyIdHomeRoute = PrototypeCCompanyIdHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => PrototypeCCompanyIdRoute,
} as any)
const PrototypeCCompanyIdSplatRoute =
  PrototypeCCompanyIdSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => PrototypeCCompanyIdRoute,
  } as any)
const AuthCCompanyIdSetupRoute = AuthCCompanyIdSetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => AuthCCompanyIdRoute,
} as any)
const AuthCCompanyIdReviewRoute = AuthCCompanyIdReviewRouteImport.update({
  id: '/review',
  path: '/review',
  getParentRoute: () => AuthCCompanyIdRoute,
} as any)
const PrototypeCCompanyIdJournalsIndexRoute =
  PrototypeCCompanyIdJournalsIndexRouteImport.update({
    id: '/journals/',
    path: '/journals/',
    getParentRoute: () => PrototypeCCompanyIdRoute,
  } as any)
const PrototypeCCompanyIdInboxIndexRoute =
  PrototypeCCompanyIdInboxIndexRouteImport.update({
    id: '/inbox/',
    path: '/inbox/',
    getParentRoute: () => PrototypeCCompanyIdRoute,
  } as any)
const PrototypeCCompanyIdBankingIndexRoute =
  PrototypeCCompanyIdBankingIndexRouteImport.update({
    id: '/banking/',
    path: '/banking/',
    getParentRoute: () => PrototypeCCompanyIdRoute,
  } as any)
const AuthCCompanyIdJournalsIndexRoute =
  AuthCCompanyIdJournalsIndexRouteImport.update({
    id: '/journals/',
    path: '/journals/',
    getParentRoute: () => AuthCCompanyIdRoute,
  } as any)
const AuthCCompanyIdBankingIndexRoute =
  AuthCCompanyIdBankingIndexRouteImport.update({
    id: '/banking/',
    path: '/banking/',
    getParentRoute: () => AuthCCompanyIdRoute,
  } as any)
const PrototypeCCompanyIdReportsTrialBalanceRoute =
  PrototypeCCompanyIdReportsTrialBalanceRouteImport.update({
    id: '/reports/trial-balance',
    path: '/reports/trial-balance',
    getParentRoute: () => PrototypeCCompanyIdRoute,
  } as any)
const PrototypeCCompanyIdReportsLedgerRoute =
  PrototypeCCompanyIdReportsLedgerRouteImport.update({
    id: '/reports/ledger',
    path: '/reports/ledger',
    getParentRoute: () => PrototypeCCompanyIdRoute,
  } as any)
const PrototypeCCompanyIdJournalsNewRoute =
  PrototypeCCompanyIdJournalsNewRouteImport.update({
    id: '/journals/new',
    path: '/journals/new',
    getParentRoute: () => PrototypeCCompanyIdRoute,
  } as any)
const PrototypeCCompanyIdJournalsEntryIdRoute =
  PrototypeCCompanyIdJournalsEntryIdRouteImport.update({
    id: '/journals/$entryId',
    path: '/journals/$entryId',
    getParentRoute: () => PrototypeCCompanyIdRoute,
  } as any)
const PrototypeCCompanyIdInboxItemIdRoute =
  PrototypeCCompanyIdInboxItemIdRouteImport.update({
    id: '/inbox/$itemId',
    path: '/inbox/$itemId',
    getParentRoute: () => PrototypeCCompanyIdRoute,
  } as any)
const AuthCCompanyIdSettingsUsersRoute =
  AuthCCompanyIdSettingsUsersRouteImport.update({
    id: '/settings/users',
    path: '/settings/users',
    getParentRoute: () => AuthCCompanyIdRoute,
  } as any)
const AuthCCompanyIdSettingsPeriodsRoute =
  AuthCCompanyIdSettingsPeriodsRouteImport.update({
    id: '/settings/periods',
    path: '/settings/periods',
    getParentRoute: () => AuthCCompanyIdRoute,
  } as any)
const AuthCCompanyIdSettingsFxRatesRoute =
  AuthCCompanyIdSettingsFxRatesRouteImport.update({
    id: '/settings/fx-rates',
    path: '/settings/fx-rates',
    getParentRoute: () => AuthCCompanyIdRoute,
  } as any)
const AuthCCompanyIdSettingsDefaultAccountsRoute =
  AuthCCompanyIdSettingsDefaultAccountsRouteImport.update({
    id: '/settings/default-accounts',
    path: '/settings/default-accounts',
    getParentRoute: () => AuthCCompanyIdRoute,
  } as any)
const AuthCCompanyIdSettingsCostCentresRoute =
  AuthCCompanyIdSettingsCostCentresRouteImport.update({
    id: '/settings/cost-centres',
    path: '/settings/cost-centres',
    getParentRoute: () => AuthCCompanyIdRoute,
  } as any)
const AuthCCompanyIdSettingsChartRoute =
  AuthCCompanyIdSettingsChartRouteImport.update({
    id: '/settings/chart',
    path: '/settings/chart',
    getParentRoute: () => AuthCCompanyIdRoute,
  } as any)
const AuthCCompanyIdSettingsApprovalsRoute =
  AuthCCompanyIdSettingsApprovalsRouteImport.update({
    id: '/settings/approvals',
    path: '/settings/approvals',
    getParentRoute: () => AuthCCompanyIdRoute,
  } as any)
const AuthCCompanyIdReportsTrialBalanceRoute =
  AuthCCompanyIdReportsTrialBalanceRouteImport.update({
    id: '/reports/trial-balance',
    path: '/reports/trial-balance',
    getParentRoute: () => AuthCCompanyIdRoute,
  } as any)
const AuthCCompanyIdReportsOpenItemsRoute =
  AuthCCompanyIdReportsOpenItemsRouteImport.update({
    id: '/reports/open-items',
    path: '/reports/open-items',
    getParentRoute: () => AuthCCompanyIdRoute,
  } as any)
const AuthCCompanyIdReportsLedgerRoute =
  AuthCCompanyIdReportsLedgerRouteImport.update({
    id: '/reports/ledger',
    path: '/reports/ledger',
    getParentRoute: () => AuthCCompanyIdRoute,
  } as any)
const AuthCCompanyIdJournalsStockCountRoute =
  AuthCCompanyIdJournalsStockCountRouteImport.update({
    id: '/journals/stock-count',
    path: '/journals/stock-count',
    getParentRoute: () => AuthCCompanyIdRoute,
  } as any)
const AuthCCompanyIdJournalsNewRoute =
  AuthCCompanyIdJournalsNewRouteImport.update({
    id: '/journals/new',
    path: '/journals/new',
    getParentRoute: () => AuthCCompanyIdRoute,
  } as any)
const AuthCCompanyIdJournalsDraftIdRoute =
  AuthCCompanyIdJournalsDraftIdRouteImport.update({
    id: '/journals/$draftId',
    path: '/journals/$draftId',
    getParentRoute: () => AuthCCompanyIdRoute,
  } as any)
const AuthCCompanyIdEntriesEntryIdRoute =
  AuthCCompanyIdEntriesEntryIdRouteImport.update({
    id: '/entries/$entryId',
    path: '/entries/$entryId',
    getParentRoute: () => AuthCCompanyIdRoute,
  } as any)
const PrototypeCCompanyIdSalesInvoicesIndexRoute =
  PrototypeCCompanyIdSalesInvoicesIndexRouteImport.update({
    id: '/sales/invoices/',
    path: '/sales/invoices/',
    getParentRoute: () => PrototypeCCompanyIdRoute,
  } as any)
const PrototypeCCompanyIdPurchasesPaymentsIndexRoute =
  PrototypeCCompanyIdPurchasesPaymentsIndexRouteImport.update({
    id: '/purchases/payments/',
    path: '/purchases/payments/',
    getParentRoute: () => PrototypeCCompanyIdRoute,
  } as any)
const PrototypeCCompanyIdPurchasesBillsIndexRoute =
  PrototypeCCompanyIdPurchasesBillsIndexRouteImport.update({
    id: '/purchases/bills/',
    path: '/purchases/bills/',
    getParentRoute: () => PrototypeCCompanyIdRoute,
  } as any)
const AuthCCompanyIdPurchasesSuppliersIndexRoute =
  AuthCCompanyIdPurchasesSuppliersIndexRouteImport.update({
    id: '/purchases/suppliers/',
    path: '/purchases/suppliers/',
    getParentRoute: () => AuthCCompanyIdRoute,
  } as any)
const AuthCCompanyIdPurchasesPaymentsIndexRoute =
  AuthCCompanyIdPurchasesPaymentsIndexRouteImport.update({
    id: '/purchases/payments/',
    path: '/purchases/payments/',
    getParentRoute: () => AuthCCompanyIdRoute,
  } as any)
const AuthCCompanyIdPurchasesCreditsIndexRoute =
  AuthCCompanyIdPurchasesCreditsIndexRouteImport.update({
    id: '/purchases/credits/',
    path: '/purchases/credits/',
    getParentRoute: () => AuthCCompanyIdRoute,
  } as any)
const AuthCCompanyIdPurchasesBillsIndexRoute =
  AuthCCompanyIdPurchasesBillsIndexRouteImport.update({
    id: '/purchases/bills/',
    path: '/purchases/bills/',
    getParentRoute: () => AuthCCompanyIdRoute,
  } as any)
const AuthCCompanyIdBankingMovementsIndexRoute =
  AuthCCompanyIdBankingMovementsIndexRouteImport.update({
    id: '/banking/movements/',
    path: '/banking/movements/',
    getParentRoute: () => AuthCCompanyIdRoute,
  } as any)
const PrototypeCCompanyIdSalesInvoicesNewRoute =
  PrototypeCCompanyIdSalesInvoicesNewRouteImport.update({
    id: '/sales/invoices/new',
    path: '/sales/invoices/new',
    getParentRoute: () => PrototypeCCompanyIdRoute,
  } as any)
const PrototypeCCompanyIdSalesInvoicesInvoiceIdRoute =
  PrototypeCCompanyIdSalesInvoicesInvoiceIdRouteImport.update({
    id: '/sales/invoices/$invoiceId',
    path: '/sales/invoices/$invoiceId',
    getParentRoute: () => PrototypeCCompanyIdRoute,
  } as any)
const PrototypeCCompanyIdPurchasesPaymentsNewRoute =
  PrototypeCCompanyIdPurchasesPaymentsNewRouteImport.update({
    id: '/purchases/payments/new',
    path: '/purchases/payments/new',
    getParentRoute: () => PrototypeCCompanyIdRoute,
  } as any)
const PrototypeCCompanyIdPurchasesPaymentsPaymentIdRoute =
  PrototypeCCompanyIdPurchasesPaymentsPaymentIdRouteImport.update({
    id: '/purchases/payments/$paymentId',
    path: '/purchases/payments/$paymentId',
    getParentRoute: () => PrototypeCCompanyIdRoute,
  } as any)
const PrototypeCCompanyIdPurchasesBillsNewRoute =
  PrototypeCCompanyIdPurchasesBillsNewRouteImport.update({
    id: '/purchases/bills/new',
    path: '/purchases/bills/new',
    getParentRoute: () => PrototypeCCompanyIdRoute,
  } as any)
const PrototypeCCompanyIdPurchasesBillsBillIdRoute =
  PrototypeCCompanyIdPurchasesBillsBillIdRouteImport.update({
    id: '/purchases/bills/$billId',
    path: '/purchases/bills/$billId',
    getParentRoute: () => PrototypeCCompanyIdRoute,
  } as any)
const PrototypeCCompanyIdBankingEasyEntriesNewRoute =
  PrototypeCCompanyIdBankingEasyEntriesNewRouteImport.update({
    id: '/banking/easy-entries/new',
    path: '/banking/easy-entries/new',
    getParentRoute: () => PrototypeCCompanyIdRoute,
  } as any)
const PrototypeCCompanyIdBankingAccountIdReconcileRoute =
  PrototypeCCompanyIdBankingAccountIdReconcileRouteImport.update({
    id: '/banking/$accountId/reconcile',
    path: '/banking/$accountId/reconcile',
    getParentRoute: () => PrototypeCCompanyIdRoute,
  } as any)
const AuthCCompanyIdPurchasesSuppliersContactIdRoute =
  AuthCCompanyIdPurchasesSuppliersContactIdRouteImport.update({
    id: '/purchases/suppliers/$contactId',
    path: '/purchases/suppliers/$contactId',
    getParentRoute: () => AuthCCompanyIdRoute,
  } as any)
const AuthCCompanyIdPurchasesPaymentsNewRoute =
  AuthCCompanyIdPurchasesPaymentsNewRouteImport.update({
    id: '/purchases/payments/new',
    path: '/purchases/payments/new',
    getParentRoute: () => AuthCCompanyIdRoute,
  } as any)
const AuthCCompanyIdPurchasesPaymentsPaymentIdRoute =
  AuthCCompanyIdPurchasesPaymentsPaymentIdRouteImport.update({
    id: '/purchases/payments/$paymentId',
    path: '/purchases/payments/$paymentId',
    getParentRoute: () => AuthCCompanyIdRoute,
  } as any)
const AuthCCompanyIdPurchasesCreditsNewRoute =
  AuthCCompanyIdPurchasesCreditsNewRouteImport.update({
    id: '/purchases/credits/new',
    path: '/purchases/credits/new',
    getParentRoute: () => AuthCCompanyIdRoute,
  } as any)
const AuthCCompanyIdPurchasesCreditsCreditIdRoute =
  AuthCCompanyIdPurchasesCreditsCreditIdRouteImport.update({
    id: '/purchases/credits/$creditId',
    path: '/purchases/credits/$creditId',
    getParentRoute: () => AuthCCompanyIdRoute,
  } as any)
const AuthCCompanyIdPurchasesBillsNewRoute =
  AuthCCompanyIdPurchasesBillsNewRouteImport.update({
    id: '/purchases/bills/new',
    path: '/purchases/bills/new',
    getParentRoute: () => AuthCCompanyIdRoute,
  } as any)
const AuthCCompanyIdPurchasesBillsBillIdRoute =
  AuthCCompanyIdPurchasesBillsBillIdRouteImport.update({
    id: '/purchases/bills/$billId',
    path: '/purchases/bills/$billId',
    getParentRoute: () => AuthCCompanyIdRoute,
  } as any)
const AuthCCompanyIdBankingMovementsNewRoute =
  AuthCCompanyIdBankingMovementsNewRouteImport.update({
    id: '/banking/movements/new',
    path: '/banking/movements/new',
    getParentRoute: () => AuthCCompanyIdRoute,
  } as any)
const AuthCCompanyIdBankingMovementsMovementIdRoute =
  AuthCCompanyIdBankingMovementsMovementIdRouteImport.update({
    id: '/banking/movements/$movementId',
    path: '/banking/movements/$movementId',
    getParentRoute: () => AuthCCompanyIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexRoute
  '/login': typeof LoginRoute
  '/prototype': typeof PrototypeRouteWithChildren
  '/no-access': typeof AuthNoAccessRoute
  '/auth/change-password': typeof AuthChangePasswordRoute
  '/auth/forgot': typeof AuthForgotRoute
  '/auth/invite': typeof AuthInviteRoute
  '/auth/reset': typeof AuthResetRoute
  '/prototype/': typeof PrototypeIndexRoute
  '/c/$companyId': typeof AuthCCompanyIdRouteWithChildren
  '/prototype/c/$companyId': typeof PrototypeCCompanyIdRouteWithChildren
  '/c/$companyId/review': typeof AuthCCompanyIdReviewRoute
  '/c/$companyId/setup': typeof AuthCCompanyIdSetupRoute
  '/prototype/c/$companyId/$': typeof PrototypeCCompanyIdSplatRoute
  '/prototype/c/$companyId/home': typeof PrototypeCCompanyIdHomeRoute
  '/prototype/c/$companyId/review': typeof PrototypeCCompanyIdReviewRoute
  '/c/$companyId/': typeof AuthCCompanyIdIndexRoute
  '/prototype/c/$companyId/': typeof PrototypeCCompanyIdIndexRoute
  '/c/$companyId/entries/$entryId': typeof AuthCCompanyIdEntriesEntryIdRoute
  '/c/$companyId/journals/$draftId': typeof AuthCCompanyIdJournalsDraftIdRoute
  '/c/$companyId/journals/new': typeof AuthCCompanyIdJournalsNewRoute
  '/c/$companyId/journals/stock-count': typeof AuthCCompanyIdJournalsStockCountRoute
  '/c/$companyId/reports/ledger': typeof AuthCCompanyIdReportsLedgerRoute
  '/c/$companyId/reports/open-items': typeof AuthCCompanyIdReportsOpenItemsRoute
  '/c/$companyId/reports/trial-balance': typeof AuthCCompanyIdReportsTrialBalanceRoute
  '/c/$companyId/settings/approvals': typeof AuthCCompanyIdSettingsApprovalsRoute
  '/c/$companyId/settings/chart': typeof AuthCCompanyIdSettingsChartRoute
  '/c/$companyId/settings/cost-centres': typeof AuthCCompanyIdSettingsCostCentresRoute
  '/c/$companyId/settings/default-accounts': typeof AuthCCompanyIdSettingsDefaultAccountsRoute
  '/c/$companyId/settings/fx-rates': typeof AuthCCompanyIdSettingsFxRatesRoute
  '/c/$companyId/settings/periods': typeof AuthCCompanyIdSettingsPeriodsRoute
  '/c/$companyId/settings/users': typeof AuthCCompanyIdSettingsUsersRoute
  '/prototype/c/$companyId/inbox/$itemId': typeof PrototypeCCompanyIdInboxItemIdRoute
  '/prototype/c/$companyId/journals/$entryId': typeof PrototypeCCompanyIdJournalsEntryIdRoute
  '/prototype/c/$companyId/journals/new': typeof PrototypeCCompanyIdJournalsNewRoute
  '/prototype/c/$companyId/reports/ledger': typeof PrototypeCCompanyIdReportsLedgerRoute
  '/prototype/c/$companyId/reports/trial-balance': typeof PrototypeCCompanyIdReportsTrialBalanceRoute
  '/c/$companyId/banking/': typeof AuthCCompanyIdBankingIndexRoute
  '/c/$companyId/journals/': typeof AuthCCompanyIdJournalsIndexRoute
  '/prototype/c/$companyId/banking/': typeof PrototypeCCompanyIdBankingIndexRoute
  '/prototype/c/$companyId/inbox/': typeof PrototypeCCompanyIdInboxIndexRoute
  '/prototype/c/$companyId/journals/': typeof PrototypeCCompanyIdJournalsIndexRoute
  '/c/$companyId/banking/movements/$movementId': typeof AuthCCompanyIdBankingMovementsMovementIdRoute
  '/c/$companyId/banking/movements/new': typeof AuthCCompanyIdBankingMovementsNewRoute
  '/c/$companyId/purchases/bills/$billId': typeof AuthCCompanyIdPurchasesBillsBillIdRoute
  '/c/$companyId/purchases/bills/new': typeof AuthCCompanyIdPurchasesBillsNewRoute
  '/c/$companyId/purchases/credits/$creditId': typeof AuthCCompanyIdPurchasesCreditsCreditIdRoute
  '/c/$companyId/purchases/credits/new': typeof AuthCCompanyIdPurchasesCreditsNewRoute
  '/c/$companyId/purchases/payments/$paymentId': typeof AuthCCompanyIdPurchasesPaymentsPaymentIdRoute
  '/c/$companyId/purchases/payments/new': typeof AuthCCompanyIdPurchasesPaymentsNewRoute
  '/c/$companyId/purchases/suppliers/$contactId': typeof AuthCCompanyIdPurchasesSuppliersContactIdRoute
  '/prototype/c/$companyId/banking/$accountId/reconcile': typeof PrototypeCCompanyIdBankingAccountIdReconcileRoute
  '/prototype/c/$companyId/banking/easy-entries/new': typeof PrototypeCCompanyIdBankingEasyEntriesNewRoute
  '/prototype/c/$companyId/purchases/bills/$billId': typeof PrototypeCCompanyIdPurchasesBillsBillIdRoute
  '/prototype/c/$companyId/purchases/bills/new': typeof PrototypeCCompanyIdPurchasesBillsNewRoute
  '/prototype/c/$companyId/purchases/payments/$paymentId': typeof PrototypeCCompanyIdPurchasesPaymentsPaymentIdRoute
  '/prototype/c/$companyId/purchases/payments/new': typeof PrototypeCCompanyIdPurchasesPaymentsNewRoute
  '/prototype/c/$companyId/sales/invoices/$invoiceId': typeof PrototypeCCompanyIdSalesInvoicesInvoiceIdRoute
  '/prototype/c/$companyId/sales/invoices/new': typeof PrototypeCCompanyIdSalesInvoicesNewRoute
  '/c/$companyId/banking/movements/': typeof AuthCCompanyIdBankingMovementsIndexRoute
  '/c/$companyId/purchases/bills/': typeof AuthCCompanyIdPurchasesBillsIndexRoute
  '/c/$companyId/purchases/credits/': typeof AuthCCompanyIdPurchasesCreditsIndexRoute
  '/c/$companyId/purchases/payments/': typeof AuthCCompanyIdPurchasesPaymentsIndexRoute
  '/c/$companyId/purchases/suppliers/': typeof AuthCCompanyIdPurchasesSuppliersIndexRoute
  '/prototype/c/$companyId/purchases/bills/': typeof PrototypeCCompanyIdPurchasesBillsIndexRoute
  '/prototype/c/$companyId/purchases/payments/': typeof PrototypeCCompanyIdPurchasesPaymentsIndexRoute
  '/prototype/c/$companyId/sales/invoices/': typeof PrototypeCCompanyIdSalesInvoicesIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/no-access': typeof AuthNoAccessRoute
  '/auth/change-password': typeof AuthChangePasswordRoute
  '/auth/forgot': typeof AuthForgotRoute
  '/auth/invite': typeof AuthInviteRoute
  '/auth/reset': typeof AuthResetRoute
  '/': typeof AuthIndexRoute
  '/prototype': typeof PrototypeIndexRoute
  '/c/$companyId/review': typeof AuthCCompanyIdReviewRoute
  '/c/$companyId/setup': typeof AuthCCompanyIdSetupRoute
  '/prototype/c/$companyId/$': typeof PrototypeCCompanyIdSplatRoute
  '/prototype/c/$companyId/home': typeof PrototypeCCompanyIdHomeRoute
  '/prototype/c/$companyId/review': typeof PrototypeCCompanyIdReviewRoute
  '/c/$companyId': typeof AuthCCompanyIdIndexRoute
  '/prototype/c/$companyId': typeof PrototypeCCompanyIdIndexRoute
  '/c/$companyId/entries/$entryId': typeof AuthCCompanyIdEntriesEntryIdRoute
  '/c/$companyId/journals/$draftId': typeof AuthCCompanyIdJournalsDraftIdRoute
  '/c/$companyId/journals/new': typeof AuthCCompanyIdJournalsNewRoute
  '/c/$companyId/journals/stock-count': typeof AuthCCompanyIdJournalsStockCountRoute
  '/c/$companyId/reports/ledger': typeof AuthCCompanyIdReportsLedgerRoute
  '/c/$companyId/reports/open-items': typeof AuthCCompanyIdReportsOpenItemsRoute
  '/c/$companyId/reports/trial-balance': typeof AuthCCompanyIdReportsTrialBalanceRoute
  '/c/$companyId/settings/approvals': typeof AuthCCompanyIdSettingsApprovalsRoute
  '/c/$companyId/settings/chart': typeof AuthCCompanyIdSettingsChartRoute
  '/c/$companyId/settings/cost-centres': typeof AuthCCompanyIdSettingsCostCentresRoute
  '/c/$companyId/settings/default-accounts': typeof AuthCCompanyIdSettingsDefaultAccountsRoute
  '/c/$companyId/settings/fx-rates': typeof AuthCCompanyIdSettingsFxRatesRoute
  '/c/$companyId/settings/periods': typeof AuthCCompanyIdSettingsPeriodsRoute
  '/c/$companyId/settings/users': typeof AuthCCompanyIdSettingsUsersRoute
  '/prototype/c/$companyId/inbox/$itemId': typeof PrototypeCCompanyIdInboxItemIdRoute
  '/prototype/c/$companyId/journals/$entryId': typeof PrototypeCCompanyIdJournalsEntryIdRoute
  '/prototype/c/$companyId/journals/new': typeof PrototypeCCompanyIdJournalsNewRoute
  '/prototype/c/$companyId/reports/ledger': typeof PrototypeCCompanyIdReportsLedgerRoute
  '/prototype/c/$companyId/reports/trial-balance': typeof PrototypeCCompanyIdReportsTrialBalanceRoute
  '/c/$companyId/banking': typeof AuthCCompanyIdBankingIndexRoute
  '/c/$companyId/journals': typeof AuthCCompanyIdJournalsIndexRoute
  '/prototype/c/$companyId/banking': typeof PrototypeCCompanyIdBankingIndexRoute
  '/prototype/c/$companyId/inbox': typeof PrototypeCCompanyIdInboxIndexRoute
  '/prototype/c/$companyId/journals': typeof PrototypeCCompanyIdJournalsIndexRoute
  '/c/$companyId/banking/movements/$movementId': typeof AuthCCompanyIdBankingMovementsMovementIdRoute
  '/c/$companyId/banking/movements/new': typeof AuthCCompanyIdBankingMovementsNewRoute
  '/c/$companyId/purchases/bills/$billId': typeof AuthCCompanyIdPurchasesBillsBillIdRoute
  '/c/$companyId/purchases/bills/new': typeof AuthCCompanyIdPurchasesBillsNewRoute
  '/c/$companyId/purchases/credits/$creditId': typeof AuthCCompanyIdPurchasesCreditsCreditIdRoute
  '/c/$companyId/purchases/credits/new': typeof AuthCCompanyIdPurchasesCreditsNewRoute
  '/c/$companyId/purchases/payments/$paymentId': typeof AuthCCompanyIdPurchasesPaymentsPaymentIdRoute
  '/c/$companyId/purchases/payments/new': typeof AuthCCompanyIdPurchasesPaymentsNewRoute
  '/c/$companyId/purchases/suppliers/$contactId': typeof AuthCCompanyIdPurchasesSuppliersContactIdRoute
  '/prototype/c/$companyId/banking/$accountId/reconcile': typeof PrototypeCCompanyIdBankingAccountIdReconcileRoute
  '/prototype/c/$companyId/banking/easy-entries/new': typeof PrototypeCCompanyIdBankingEasyEntriesNewRoute
  '/prototype/c/$companyId/purchases/bills/$billId': typeof PrototypeCCompanyIdPurchasesBillsBillIdRoute
  '/prototype/c/$companyId/purchases/bills/new': typeof PrototypeCCompanyIdPurchasesBillsNewRoute
  '/prototype/c/$companyId/purchases/payments/$paymentId': typeof PrototypeCCompanyIdPurchasesPaymentsPaymentIdRoute
  '/prototype/c/$companyId/purchases/payments/new': typeof PrototypeCCompanyIdPurchasesPaymentsNewRoute
  '/prototype/c/$companyId/sales/invoices/$invoiceId': typeof PrototypeCCompanyIdSalesInvoicesInvoiceIdRoute
  '/prototype/c/$companyId/sales/invoices/new': typeof PrototypeCCompanyIdSalesInvoicesNewRoute
  '/c/$companyId/banking/movements': typeof AuthCCompanyIdBankingMovementsIndexRoute
  '/c/$companyId/purchases/bills': typeof AuthCCompanyIdPurchasesBillsIndexRoute
  '/c/$companyId/purchases/credits': typeof AuthCCompanyIdPurchasesCreditsIndexRoute
  '/c/$companyId/purchases/payments': typeof AuthCCompanyIdPurchasesPaymentsIndexRoute
  '/c/$companyId/purchases/suppliers': typeof AuthCCompanyIdPurchasesSuppliersIndexRoute
  '/prototype/c/$companyId/purchases/bills': typeof PrototypeCCompanyIdPurchasesBillsIndexRoute
  '/prototype/c/$companyId/purchases/payments': typeof PrototypeCCompanyIdPurchasesPaymentsIndexRoute
  '/prototype/c/$companyId/sales/invoices': typeof PrototypeCCompanyIdSalesInvoicesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/prototype': typeof PrototypeRouteWithChildren
  '/_auth/no-access': typeof AuthNoAccessRoute
  '/auth/change-password': typeof AuthChangePasswordRoute
  '/auth/forgot': typeof AuthForgotRoute
  '/auth/invite': typeof AuthInviteRoute
  '/auth/reset': typeof AuthResetRoute
  '/_auth/': typeof AuthIndexRoute
  '/prototype/': typeof PrototypeIndexRoute
  '/_auth/c/$companyId': typeof AuthCCompanyIdRouteWithChildren
  '/prototype/c/$companyId': typeof PrototypeCCompanyIdRouteWithChildren
  '/_auth/c/$companyId/review': typeof AuthCCompanyIdReviewRoute
  '/_auth/c/$companyId/setup': typeof AuthCCompanyIdSetupRoute
  '/prototype/c/$companyId/$': typeof PrototypeCCompanyIdSplatRoute
  '/prototype/c/$companyId/home': typeof PrototypeCCompanyIdHomeRoute
  '/prototype/c/$companyId/review': typeof PrototypeCCompanyIdReviewRoute
  '/_auth/c/$companyId/': typeof AuthCCompanyIdIndexRoute
  '/prototype/c/$companyId/': typeof PrototypeCCompanyIdIndexRoute
  '/_auth/c/$companyId/entries/$entryId': typeof AuthCCompanyIdEntriesEntryIdRoute
  '/_auth/c/$companyId/journals/$draftId': typeof AuthCCompanyIdJournalsDraftIdRoute
  '/_auth/c/$companyId/journals/new': typeof AuthCCompanyIdJournalsNewRoute
  '/_auth/c/$companyId/journals/stock-count': typeof AuthCCompanyIdJournalsStockCountRoute
  '/_auth/c/$companyId/reports/ledger': typeof AuthCCompanyIdReportsLedgerRoute
  '/_auth/c/$companyId/reports/open-items': typeof AuthCCompanyIdReportsOpenItemsRoute
  '/_auth/c/$companyId/reports/trial-balance': typeof AuthCCompanyIdReportsTrialBalanceRoute
  '/_auth/c/$companyId/settings/approvals': typeof AuthCCompanyIdSettingsApprovalsRoute
  '/_auth/c/$companyId/settings/chart': typeof AuthCCompanyIdSettingsChartRoute
  '/_auth/c/$companyId/settings/cost-centres': typeof AuthCCompanyIdSettingsCostCentresRoute
  '/_auth/c/$companyId/settings/default-accounts': typeof AuthCCompanyIdSettingsDefaultAccountsRoute
  '/_auth/c/$companyId/settings/fx-rates': typeof AuthCCompanyIdSettingsFxRatesRoute
  '/_auth/c/$companyId/settings/periods': typeof AuthCCompanyIdSettingsPeriodsRoute
  '/_auth/c/$companyId/settings/users': typeof AuthCCompanyIdSettingsUsersRoute
  '/prototype/c/$companyId/inbox/$itemId': typeof PrototypeCCompanyIdInboxItemIdRoute
  '/prototype/c/$companyId/journals/$entryId': typeof PrototypeCCompanyIdJournalsEntryIdRoute
  '/prototype/c/$companyId/journals/new': typeof PrototypeCCompanyIdJournalsNewRoute
  '/prototype/c/$companyId/reports/ledger': typeof PrototypeCCompanyIdReportsLedgerRoute
  '/prototype/c/$companyId/reports/trial-balance': typeof PrototypeCCompanyIdReportsTrialBalanceRoute
  '/_auth/c/$companyId/banking/': typeof AuthCCompanyIdBankingIndexRoute
  '/_auth/c/$companyId/journals/': typeof AuthCCompanyIdJournalsIndexRoute
  '/prototype/c/$companyId/banking/': typeof PrototypeCCompanyIdBankingIndexRoute
  '/prototype/c/$companyId/inbox/': typeof PrototypeCCompanyIdInboxIndexRoute
  '/prototype/c/$companyId/journals/': typeof PrototypeCCompanyIdJournalsIndexRoute
  '/_auth/c/$companyId/banking/movements/$movementId': typeof AuthCCompanyIdBankingMovementsMovementIdRoute
  '/_auth/c/$companyId/banking/movements/new': typeof AuthCCompanyIdBankingMovementsNewRoute
  '/_auth/c/$companyId/purchases/bills/$billId': typeof AuthCCompanyIdPurchasesBillsBillIdRoute
  '/_auth/c/$companyId/purchases/bills/new': typeof AuthCCompanyIdPurchasesBillsNewRoute
  '/_auth/c/$companyId/purchases/credits/$creditId': typeof AuthCCompanyIdPurchasesCreditsCreditIdRoute
  '/_auth/c/$companyId/purchases/credits/new': typeof AuthCCompanyIdPurchasesCreditsNewRoute
  '/_auth/c/$companyId/purchases/payments/$paymentId': typeof AuthCCompanyIdPurchasesPaymentsPaymentIdRoute
  '/_auth/c/$companyId/purchases/payments/new': typeof AuthCCompanyIdPurchasesPaymentsNewRoute
  '/_auth/c/$companyId/purchases/suppliers/$contactId': typeof AuthCCompanyIdPurchasesSuppliersContactIdRoute
  '/prototype/c/$companyId/banking/$accountId/reconcile': typeof PrototypeCCompanyIdBankingAccountIdReconcileRoute
  '/prototype/c/$companyId/banking/easy-entries/new': typeof PrototypeCCompanyIdBankingEasyEntriesNewRoute
  '/prototype/c/$companyId/purchases/bills/$billId': typeof PrototypeCCompanyIdPurchasesBillsBillIdRoute
  '/prototype/c/$companyId/purchases/bills/new': typeof PrototypeCCompanyIdPurchasesBillsNewRoute
  '/prototype/c/$companyId/purchases/payments/$paymentId': typeof PrototypeCCompanyIdPurchasesPaymentsPaymentIdRoute
  '/prototype/c/$companyId/purchases/payments/new': typeof PrototypeCCompanyIdPurchasesPaymentsNewRoute
  '/prototype/c/$companyId/sales/invoices/$invoiceId': typeof PrototypeCCompanyIdSalesInvoicesInvoiceIdRoute
  '/prototype/c/$companyId/sales/invoices/new': typeof PrototypeCCompanyIdSalesInvoicesNewRoute
  '/_auth/c/$companyId/banking/movements/': typeof AuthCCompanyIdBankingMovementsIndexRoute
  '/_auth/c/$companyId/purchases/bills/': typeof AuthCCompanyIdPurchasesBillsIndexRoute
  '/_auth/c/$companyId/purchases/credits/': typeof AuthCCompanyIdPurchasesCreditsIndexRoute
  '/_auth/c/$companyId/purchases/payments/': typeof AuthCCompanyIdPurchasesPaymentsIndexRoute
  '/_auth/c/$companyId/purchases/suppliers/': typeof AuthCCompanyIdPurchasesSuppliersIndexRoute
  '/prototype/c/$companyId/purchases/bills/': typeof PrototypeCCompanyIdPurchasesBillsIndexRoute
  '/prototype/c/$companyId/purchases/payments/': typeof PrototypeCCompanyIdPurchasesPaymentsIndexRoute
  '/prototype/c/$companyId/sales/invoices/': typeof PrototypeCCompanyIdSalesInvoicesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/prototype'
    | '/no-access'
    | '/auth/change-password'
    | '/auth/forgot'
    | '/auth/invite'
    | '/auth/reset'
    | '/prototype/'
    | '/c/$companyId'
    | '/prototype/c/$companyId'
    | '/c/$companyId/review'
    | '/c/$companyId/setup'
    | '/prototype/c/$companyId/$'
    | '/prototype/c/$companyId/home'
    | '/prototype/c/$companyId/review'
    | '/c/$companyId/'
    | '/prototype/c/$companyId/'
    | '/c/$companyId/entries/$entryId'
    | '/c/$companyId/journals/$draftId'
    | '/c/$companyId/journals/new'
    | '/c/$companyId/journals/stock-count'
    | '/c/$companyId/reports/ledger'
    | '/c/$companyId/reports/open-items'
    | '/c/$companyId/reports/trial-balance'
    | '/c/$companyId/settings/approvals'
    | '/c/$companyId/settings/chart'
    | '/c/$companyId/settings/cost-centres'
    | '/c/$companyId/settings/default-accounts'
    | '/c/$companyId/settings/fx-rates'
    | '/c/$companyId/settings/periods'
    | '/c/$companyId/settings/users'
    | '/prototype/c/$companyId/inbox/$itemId'
    | '/prototype/c/$companyId/journals/$entryId'
    | '/prototype/c/$companyId/journals/new'
    | '/prototype/c/$companyId/reports/ledger'
    | '/prototype/c/$companyId/reports/trial-balance'
    | '/c/$companyId/banking/'
    | '/c/$companyId/journals/'
    | '/prototype/c/$companyId/banking/'
    | '/prototype/c/$companyId/inbox/'
    | '/prototype/c/$companyId/journals/'
    | '/c/$companyId/banking/movements/$movementId'
    | '/c/$companyId/banking/movements/new'
    | '/c/$companyId/purchases/bills/$billId'
    | '/c/$companyId/purchases/bills/new'
    | '/c/$companyId/purchases/credits/$creditId'
    | '/c/$companyId/purchases/credits/new'
    | '/c/$companyId/purchases/payments/$paymentId'
    | '/c/$companyId/purchases/payments/new'
    | '/c/$companyId/purchases/suppliers/$contactId'
    | '/prototype/c/$companyId/banking/$accountId/reconcile'
    | '/prototype/c/$companyId/banking/easy-entries/new'
    | '/prototype/c/$companyId/purchases/bills/$billId'
    | '/prototype/c/$companyId/purchases/bills/new'
    | '/prototype/c/$companyId/purchases/payments/$paymentId'
    | '/prototype/c/$companyId/purchases/payments/new'
    | '/prototype/c/$companyId/sales/invoices/$invoiceId'
    | '/prototype/c/$companyId/sales/invoices/new'
    | '/c/$companyId/banking/movements/'
    | '/c/$companyId/purchases/bills/'
    | '/c/$companyId/purchases/credits/'
    | '/c/$companyId/purchases/payments/'
    | '/c/$companyId/purchases/suppliers/'
    | '/prototype/c/$companyId/purchases/bills/'
    | '/prototype/c/$companyId/purchases/payments/'
    | '/prototype/c/$companyId/sales/invoices/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/no-access'
    | '/auth/change-password'
    | '/auth/forgot'
    | '/auth/invite'
    | '/auth/reset'
    | '/'
    | '/prototype'
    | '/c/$companyId/review'
    | '/c/$companyId/setup'
    | '/prototype/c/$companyId/$'
    | '/prototype/c/$companyId/home'
    | '/prototype/c/$companyId/review'
    | '/c/$companyId'
    | '/prototype/c/$companyId'
    | '/c/$companyId/entries/$entryId'
    | '/c/$companyId/journals/$draftId'
    | '/c/$companyId/journals/new'
    | '/c/$companyId/journals/stock-count'
    | '/c/$companyId/reports/ledger'
    | '/c/$companyId/reports/open-items'
    | '/c/$companyId/reports/trial-balance'
    | '/c/$companyId/settings/approvals'
    | '/c/$companyId/settings/chart'
    | '/c/$companyId/settings/cost-centres'
    | '/c/$companyId/settings/default-accounts'
    | '/c/$companyId/settings/fx-rates'
    | '/c/$companyId/settings/periods'
    | '/c/$companyId/settings/users'
    | '/prototype/c/$companyId/inbox/$itemId'
    | '/prototype/c/$companyId/journals/$entryId'
    | '/prototype/c/$companyId/journals/new'
    | '/prototype/c/$companyId/reports/ledger'
    | '/prototype/c/$companyId/reports/trial-balance'
    | '/c/$companyId/banking'
    | '/c/$companyId/journals'
    | '/prototype/c/$companyId/banking'
    | '/prototype/c/$companyId/inbox'
    | '/prototype/c/$companyId/journals'
    | '/c/$companyId/banking/movements/$movementId'
    | '/c/$companyId/banking/movements/new'
    | '/c/$companyId/purchases/bills/$billId'
    | '/c/$companyId/purchases/bills/new'
    | '/c/$companyId/purchases/credits/$creditId'
    | '/c/$companyId/purchases/credits/new'
    | '/c/$companyId/purchases/payments/$paymentId'
    | '/c/$companyId/purchases/payments/new'
    | '/c/$companyId/purchases/suppliers/$contactId'
    | '/prototype/c/$companyId/banking/$accountId/reconcile'
    | '/prototype/c/$companyId/banking/easy-entries/new'
    | '/prototype/c/$companyId/purchases/bills/$billId'
    | '/prototype/c/$companyId/purchases/bills/new'
    | '/prototype/c/$companyId/purchases/payments/$paymentId'
    | '/prototype/c/$companyId/purchases/payments/new'
    | '/prototype/c/$companyId/sales/invoices/$invoiceId'
    | '/prototype/c/$companyId/sales/invoices/new'
    | '/c/$companyId/banking/movements'
    | '/c/$companyId/purchases/bills'
    | '/c/$companyId/purchases/credits'
    | '/c/$companyId/purchases/payments'
    | '/c/$companyId/purchases/suppliers'
    | '/prototype/c/$companyId/purchases/bills'
    | '/prototype/c/$companyId/purchases/payments'
    | '/prototype/c/$companyId/sales/invoices'
  id:
    | '__root__'
    | '/_auth'
    | '/login'
    | '/prototype'
    | '/_auth/no-access'
    | '/auth/change-password'
    | '/auth/forgot'
    | '/auth/invite'
    | '/auth/reset'
    | '/_auth/'
    | '/prototype/'
    | '/_auth/c/$companyId'
    | '/prototype/c/$companyId'
    | '/_auth/c/$companyId/review'
    | '/_auth/c/$companyId/setup'
    | '/prototype/c/$companyId/$'
    | '/prototype/c/$companyId/home'
    | '/prototype/c/$companyId/review'
    | '/_auth/c/$companyId/'
    | '/prototype/c/$companyId/'
    | '/_auth/c/$companyId/entries/$entryId'
    | '/_auth/c/$companyId/journals/$draftId'
    | '/_auth/c/$companyId/journals/new'
    | '/_auth/c/$companyId/journals/stock-count'
    | '/_auth/c/$companyId/reports/ledger'
    | '/_auth/c/$companyId/reports/open-items'
    | '/_auth/c/$companyId/reports/trial-balance'
    | '/_auth/c/$companyId/settings/approvals'
    | '/_auth/c/$companyId/settings/chart'
    | '/_auth/c/$companyId/settings/cost-centres'
    | '/_auth/c/$companyId/settings/default-accounts'
    | '/_auth/c/$companyId/settings/fx-rates'
    | '/_auth/c/$companyId/settings/periods'
    | '/_auth/c/$companyId/settings/users'
    | '/prototype/c/$companyId/inbox/$itemId'
    | '/prototype/c/$companyId/journals/$entryId'
    | '/prototype/c/$companyId/journals/new'
    | '/prototype/c/$companyId/reports/ledger'
    | '/prototype/c/$companyId/reports/trial-balance'
    | '/_auth/c/$companyId/banking/'
    | '/_auth/c/$companyId/journals/'
    | '/prototype/c/$companyId/banking/'
    | '/prototype/c/$companyId/inbox/'
    | '/prototype/c/$companyId/journals/'
    | '/_auth/c/$companyId/banking/movements/$movementId'
    | '/_auth/c/$companyId/banking/movements/new'
    | '/_auth/c/$companyId/purchases/bills/$billId'
    | '/_auth/c/$companyId/purchases/bills/new'
    | '/_auth/c/$companyId/purchases/credits/$creditId'
    | '/_auth/c/$companyId/purchases/credits/new'
    | '/_auth/c/$companyId/purchases/payments/$paymentId'
    | '/_auth/c/$companyId/purchases/payments/new'
    | '/_auth/c/$companyId/purchases/suppliers/$contactId'
    | '/prototype/c/$companyId/banking/$accountId/reconcile'
    | '/prototype/c/$companyId/banking/easy-entries/new'
    | '/prototype/c/$companyId/purchases/bills/$billId'
    | '/prototype/c/$companyId/purchases/bills/new'
    | '/prototype/c/$companyId/purchases/payments/$paymentId'
    | '/prototype/c/$companyId/purchases/payments/new'
    | '/prototype/c/$companyId/sales/invoices/$invoiceId'
    | '/prototype/c/$companyId/sales/invoices/new'
    | '/_auth/c/$companyId/banking/movements/'
    | '/_auth/c/$companyId/purchases/bills/'
    | '/_auth/c/$companyId/purchases/credits/'
    | '/_auth/c/$companyId/purchases/payments/'
    | '/_auth/c/$companyId/purchases/suppliers/'
    | '/prototype/c/$companyId/purchases/bills/'
    | '/prototype/c/$companyId/purchases/payments/'
    | '/prototype/c/$companyId/sales/invoices/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  LoginRoute: typeof LoginRoute
  PrototypeRoute: typeof PrototypeRouteWithChildren
  AuthChangePasswordRoute: typeof AuthChangePasswordRoute
  AuthForgotRoute: typeof AuthForgotRoute
  AuthInviteRoute: typeof AuthInviteRoute
  AuthResetRoute: typeof AuthResetRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/prototype': {
      id: '/prototype'
      path: '/prototype'
      fullPath: '/prototype'
      preLoaderRoute: typeof PrototypeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prototype/': {
      id: '/prototype/'
      path: '/'
      fullPath: '/prototype/'
      preLoaderRoute: typeof PrototypeIndexRouteImport
      parentRoute: typeof PrototypeRoute
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/reset': {
      id: '/auth/reset'
      path: '/auth/reset'
      fullPath: '/auth/reset'
      preLoaderRoute: typeof AuthResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/invite': {
      id: '/auth/invite'
      path: '/auth/invite'
      fullPath: '/auth/invite'
      preLoaderRoute: typeof AuthInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/forgot': {
      id: '/auth/forgot'
      path: '/auth/forgot'
      fullPath: '/auth/forgot'
      preLoaderRoute: typeof AuthForgotRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/change-password': {
      id: '/auth/change-password'
      path: '/auth/change-password'
      fullPath: '/auth/change-password'
      preLoaderRoute: typeof AuthChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/no-access': {
      id: '/_auth/no-access'
      path: '/no-access'
      fullPath: '/no-access'
      preLoaderRoute: typeof AuthNoAccessRouteImport
      parentRoute: typeof AuthRoute
    }
    '/prototype/c/$companyId': {
      id: '/prototype/c/$companyId'
      path: '/c/$companyId'
      fullPath: '/prototype/c/$companyId'
      preLoaderRoute: typeof PrototypeCCompanyIdRouteImport
      parentRoute: typeof PrototypeRoute
    }
    '/_auth/c/$companyId': {
      id: '/_auth/c/$companyId'
      path: '/c/$companyId'
      fullPath: '/c/$companyId'
      preLoaderRoute: typeof AuthCCompanyIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/prototype/c/$companyId/': {
      id: '/prototype/c/$companyId/'
      path: '/'
      fullPath: '/prototype/c/$companyId/'
      preLoaderRoute: typeof PrototypeCCompanyIdIndexRouteImport
      parentRoute: typeof PrototypeCCompanyIdRoute
    }
    '/_auth/c/$companyId/': {
      id: '/_auth/c/$companyId/'
      path: '/'
      fullPath: '/c/$companyId/'
      preLoaderRoute: typeof AuthCCompanyIdIndexRouteImport
      parentRoute: typeof AuthCCompanyIdRoute
    }
    '/prototype/c/$companyId/review': {
      id: '/prototype/c/$companyId/review'
      path: '/review'
      fullPath: '/prototype/c/$companyId/review'
      preLoaderRoute: typeof PrototypeCCompanyIdReviewRouteImport
      parentRoute: typeof PrototypeCCompanyIdRoute
    }
    '/prototype/c/$companyId/home': {
      id: '/prototype/c/$companyId/home'
      path: '/home'
      fullPath: '/prototype/c/$companyId/home'
      preLoaderRoute: typeof PrototypeCCompanyIdHomeRouteImport
      parentRoute: typeof PrototypeCCompanyIdRoute
    }
    '/prototype/c/$companyId/$': {
      id: '/prototype/c/$companyId/$'
      path: '/$'
      fullPath: '/prototype/c/$companyId/$'
      preLoaderRoute: typeof PrototypeCCompanyIdSplatRouteImport
      parentRoute: typeof PrototypeCCompanyIdRoute
    }
    '/_auth/c/$companyId/setup': {
      id: '/_auth/c/$companyId/setup'
      path: '/setup'
      fullPath: '/c/$companyId/setup'
      preLoaderRoute: typeof AuthCCompanyIdSetupRouteImport
      parentRoute: typeof AuthCCompanyIdRoute
    }
    '/_auth/c/$companyId/review': {
      id: '/_auth/c/$companyId/review'
      path: '/review'
      fullPath: '/c/$companyId/review'
      preLoaderRoute: typeof AuthCCompanyIdReviewRouteImport
      parentRoute: typeof AuthCCompanyIdRoute
    }
    '/prototype/c/$companyId/journals/': {
      id: '/prototype/c/$companyId/journals/'
      path: '/journals'
      fullPath: '/prototype/c/$companyId/journals/'
      preLoaderRoute: typeof PrototypeCCompanyIdJournalsIndexRouteImport
      parentRoute: typeof PrototypeCCompanyIdRoute
    }
    '/prototype/c/$companyId/inbox/': {
      id: '/prototype/c/$companyId/inbox/'
      path: '/inbox'
      fullPath: '/prototype/c/$companyId/inbox/'
      preLoaderRoute: typeof PrototypeCCompanyIdInboxIndexRouteImport
      parentRoute: typeof PrototypeCCompanyIdRoute
    }
    '/prototype/c/$companyId/banking/': {
      id: '/prototype/c/$companyId/banking/'
      path: '/banking'
      fullPath: '/prototype/c/$companyId/banking/'
      preLoaderRoute: typeof PrototypeCCompanyIdBankingIndexRouteImport
      parentRoute: typeof PrototypeCCompanyIdRoute
    }
    '/_auth/c/$companyId/journals/': {
      id: '/_auth/c/$companyId/journals/'
      path: '/journals'
      fullPath: '/c/$companyId/journals/'
      preLoaderRoute: typeof AuthCCompanyIdJournalsIndexRouteImport
      parentRoute: typeof AuthCCompanyIdRoute
    }
    '/_auth/c/$companyId/banking/': {
      id: '/_auth/c/$companyId/banking/'
      path: '/banking'
      fullPath: '/c/$companyId/banking/'
      preLoaderRoute: typeof AuthCCompanyIdBankingIndexRouteImport
      parentRoute: typeof AuthCCompanyIdRoute
    }
    '/prototype/c/$companyId/reports/trial-balance': {
      id: '/prototype/c/$companyId/reports/trial-balance'
      path: '/reports/trial-balance'
      fullPath: '/prototype/c/$companyId/reports/trial-balance'
      preLoaderRoute: typeof PrototypeCCompanyIdReportsTrialBalanceRouteImport
      parentRoute: typeof PrototypeCCompanyIdRoute
    }
    '/prototype/c/$companyId/reports/ledger': {
      id: '/prototype/c/$companyId/reports/ledger'
      path: '/reports/ledger'
      fullPath: '/prototype/c/$companyId/reports/ledger'
      preLoaderRoute: typeof PrototypeCCompanyIdReportsLedgerRouteImport
      parentRoute: typeof PrototypeCCompanyIdRoute
    }
    '/prototype/c/$companyId/journals/new': {
      id: '/prototype/c/$companyId/journals/new'
      path: '/journals/new'
      fullPath: '/prototype/c/$companyId/journals/new'
      preLoaderRoute: typeof PrototypeCCompanyIdJournalsNewRouteImport
      parentRoute: typeof PrototypeCCompanyIdRoute
    }
    '/prototype/c/$companyId/journals/$entryId': {
      id: '/prototype/c/$companyId/journals/$entryId'
      path: '/journals/$entryId'
      fullPath: '/prototype/c/$companyId/journals/$entryId'
      preLoaderRoute: typeof PrototypeCCompanyIdJournalsEntryIdRouteImport
      parentRoute: typeof PrototypeCCompanyIdRoute
    }
    '/prototype/c/$companyId/inbox/$itemId': {
      id: '/prototype/c/$companyId/inbox/$itemId'
      path: '/inbox/$itemId'
      fullPath: '/prototype/c/$companyId/inbox/$itemId'
      preLoaderRoute: typeof PrototypeCCompanyIdInboxItemIdRouteImport
      parentRoute: typeof PrototypeCCompanyIdRoute
    }
    '/_auth/c/$companyId/settings/users': {
      id: '/_auth/c/$companyId/settings/users'
      path: '/settings/users'
      fullPath: '/c/$companyId/settings/users'
      preLoaderRoute: typeof AuthCCompanyIdSettingsUsersRouteImport
      parentRoute: typeof AuthCCompanyIdRoute
    }
    '/_auth/c/$companyId/settings/periods': {
      id: '/_auth/c/$companyId/settings/periods'
      path: '/settings/periods'
      fullPath: '/c/$companyId/settings/periods'
      preLoaderRoute: typeof AuthCCompanyIdSettingsPeriodsRouteImport
      parentRoute: typeof AuthCCompanyIdRoute
    }
    '/_auth/c/$companyId/settings/fx-rates': {
      id: '/_auth/c/$companyId/settings/fx-rates'
      path: '/settings/fx-rates'
      fullPath: '/c/$companyId/settings/fx-rates'
      preLoaderRoute: typeof AuthCCompanyIdSettingsFxRatesRouteImport
      parentRoute: typeof AuthCCompanyIdRoute
    }
    '/_auth/c/$companyId/settings/default-accounts': {
      id: '/_auth/c/$companyId/settings/default-accounts'
      path: '/settings/default-accounts'
      fullPath: '/c/$companyId/settings/default-accounts'
      preLoaderRoute: typeof AuthCCompanyIdSettingsDefaultAccountsRouteImport
      parentRoute: typeof AuthCCompanyIdRoute
    }
    '/_auth/c/$companyId/settings/cost-centres': {
      id: '/_auth/c/$companyId/settings/cost-centres'
      path: '/settings/cost-centres'
      fullPath: '/c/$companyId/settings/cost-centres'
      preLoaderRoute: typeof AuthCCompanyIdSettingsCostCentresRouteImport
      parentRoute: typeof AuthCCompanyIdRoute
    }
    '/_auth/c/$companyId/settings/chart': {
      id: '/_auth/c/$companyId/settings/chart'
      path: '/settings/chart'
      fullPath: '/c/$companyId/settings/chart'
      preLoaderRoute: typeof AuthCCompanyIdSettingsChartRouteImport
      parentRoute: typeof AuthCCompanyIdRoute
    }
    '/_auth/c/$companyId/settings/approvals': {
      id: '/_auth/c/$companyId/settings/approvals'
      path: '/settings/approvals'
      fullPath: '/c/$companyId/settings/approvals'
      preLoaderRoute: typeof AuthCCompanyIdSettingsApprovalsRouteImport
      parentRoute: typeof AuthCCompanyIdRoute
    }
    '/_auth/c/$companyId/reports/trial-balance': {
      id: '/_auth/c/$companyId/reports/trial-balance'
      path: '/reports/trial-balance'
      fullPath: '/c/$companyId/reports/trial-balance'
      preLoaderRoute: typeof AuthCCompanyIdReportsTrialBalanceRouteImport
      parentRoute: typeof AuthCCompanyIdRoute
    }
    '/_auth/c/$companyId/reports/open-items': {
      id: '/_auth/c/$companyId/reports/open-items'
      path: '/reports/open-items'
      fullPath: '/c/$companyId/reports/open-items'
      preLoaderRoute: typeof AuthCCompanyIdReportsOpenItemsRouteImport
      parentRoute: typeof AuthCCompanyIdRoute
    }
    '/_auth/c/$companyId/reports/ledger': {
      id: '/_auth/c/$companyId/reports/ledger'
      path: '/reports/ledger'
      fullPath: '/c/$companyId/reports/ledger'
      preLoaderRoute: typeof AuthCCompanyIdReportsLedgerRouteImport
      parentRoute: typeof AuthCCompanyIdRoute
    }
    '/_auth/c/$companyId/journals/stock-count': {
      id: '/_auth/c/$companyId/journals/stock-count'
      path: '/journals/stock-count'
      fullPath: '/c/$companyId/journals/stock-count'
      preLoaderRoute: typeof AuthCCompanyIdJournalsStockCountRouteImport
      parentRoute: typeof AuthCCompanyIdRoute
    }
    '/_auth/c/$companyId/journals/new': {
      id: '/_auth/c/$companyId/journals/new'
      path: '/journals/new'
      fullPath: '/c/$companyId/journals/new'
      preLoaderRoute: typeof AuthCCompanyIdJournalsNewRouteImport
      parentRoute: typeof AuthCCompanyIdRoute
    }
    '/_auth/c/$companyId/journals/$draftId': {
      id: '/_auth/c/$companyId/journals/$draftId'
      path: '/journals/$draftId'
      fullPath: '/c/$companyId/journals/$draftId'
      preLoaderRoute: typeof AuthCCompanyIdJournalsDraftIdRouteImport
      parentRoute: typeof AuthCCompanyIdRoute
    }
    '/_auth/c/$companyId/entries/$entryId': {
      id: '/_auth/c/$companyId/entries/$entryId'
      path: '/entries/$entryId'
      fullPath: '/c/$companyId/entries/$entryId'
      preLoaderRoute: typeof AuthCCompanyIdEntriesEntryIdRouteImport
      parentRoute: typeof AuthCCompanyIdRoute
    }
    '/prototype/c/$companyId/sales/invoices/': {
      id: '/prototype/c/$companyId/sales/invoices/'
      path: '/sales/invoices'
      fullPath: '/prototype/c/$companyId/sales/invoices/'
      preLoaderRoute: typeof PrototypeCCompanyIdSalesInvoicesIndexRouteImport
      parentRoute: typeof PrototypeCCompanyIdRoute
    }
    '/prototype/c/$companyId/purchases/payments/': {
      id: '/prototype/c/$companyId/purchases/payments/'
      path: '/purchases/payments'
      fullPath: '/prototype/c/$companyId/purchases/payments/'
      preLoaderRoute: typeof PrototypeCCompanyIdPurchasesPaymentsIndexRouteImport
      parentRoute: typeof PrototypeCCompanyIdRoute
    }
    '/prototype/c/$companyId/purchases/bills/': {
      id: '/prototype/c/$companyId/purchases/bills/'
      path: '/purchases/bills'
      fullPath: '/prototype/c/$companyId/purchases/bills/'
      preLoaderRoute: typeof PrototypeCCompanyIdPurchasesBillsIndexRouteImport
      parentRoute: typeof PrototypeCCompanyIdRoute
    }
    '/_auth/c/$companyId/purchases/suppliers/': {
      id: '/_auth/c/$companyId/purchases/suppliers/'
      path: '/purchases/suppliers'
      fullPath: '/c/$companyId/purchases/suppliers/'
      preLoaderRoute: typeof AuthCCompanyIdPurchasesSuppliersIndexRouteImport
      parentRoute: typeof AuthCCompanyIdRoute
    }
    '/_auth/c/$companyId/purchases/payments/': {
      id: '/_auth/c/$companyId/purchases/payments/'
      path: '/purchases/payments'
      fullPath: '/c/$companyId/purchases/payments/'
      preLoaderRoute: typeof AuthCCompanyIdPurchasesPaymentsIndexRouteImport
      parentRoute: typeof AuthCCompanyIdRoute
    }
    '/_auth/c/$companyId/purchases/credits/': {
      id: '/_auth/c/$companyId/purchases/credits/'
      path: '/purchases/credits'
      fullPath: '/c/$companyId/purchases/credits/'
      preLoaderRoute: typeof AuthCCompanyIdPurchasesCreditsIndexRouteImport
      parentRoute: typeof AuthCCompanyIdRoute
    }
    '/_auth/c/$companyId/purchases/bills/': {
      id: '/_auth/c/$companyId/purchases/bills/'
      path: '/purchases/bills'
      fullPath: '/c/$companyId/purchases/bills/'
      preLoaderRoute: typeof AuthCCompanyIdPurchasesBillsIndexRouteImport
      parentRoute: typeof AuthCCompanyIdRoute
    }
    '/_auth/c/$companyId/banking/movements/': {
      id: '/_auth/c/$companyId/banking/movements/'
      path: '/banking/movements'
      fullPath: '/c/$companyId/banking/movements/'
      preLoaderRoute: typeof AuthCCompanyIdBankingMovementsIndexRouteImport
      parentRoute: typeof AuthCCompanyIdRoute
    }
    '/prototype/c/$companyId/sales/invoices/new': {
      id: '/prototype/c/$companyId/sales/invoices/new'
      path: '/sales/invoices/new'
      fullPath: '/prototype/c/$companyId/sales/invoices/new'
      preLoaderRoute: typeof PrototypeCCompanyIdSalesInvoicesNewRouteImport
      parentRoute: typeof PrototypeCCompanyIdRoute
    }
    '/prototype/c/$companyId/sales/invoices/$invoiceId': {
      id: '/prototype/c/$companyId/sales/invoices/$invoiceId'
      path: '/sales/invoices/$invoiceId'
      fullPath: '/prototype/c/$companyId/sales/invoices/$invoiceId'
      preLoaderRoute: typeof PrototypeCCompanyIdSalesInvoicesInvoiceIdRouteImport
      parentRoute: typeof PrototypeCCompanyIdRoute
    }
    '/prototype/c/$companyId/purchases/payments/new': {
      id: '/prototype/c/$companyId/purchases/payments/new'
      path: '/purchases/payments/new'
      fullPath: '/prototype/c/$companyId/purchases/payments/new'
      preLoaderRoute: typeof PrototypeCCompanyIdPurchasesPaymentsNewRouteImport
      parentRoute: typeof PrototypeCCompanyIdRoute
    }
    '/prototype/c/$companyId/purchases/payments/$paymentId': {
      id: '/prototype/c/$companyId/purchases/payments/$paymentId'
      path: '/purchases/payments/$paymentId'
      fullPath: '/prototype/c/$companyId/purchases/payments/$paymentId'
      preLoaderRoute: typeof PrototypeCCompanyIdPurchasesPaymentsPaymentIdRouteImport
      parentRoute: typeof PrototypeCCompanyIdRoute
    }
    '/prototype/c/$companyId/purchases/bills/new': {
      id: '/prototype/c/$companyId/purchases/bills/new'
      path: '/purchases/bills/new'
      fullPath: '/prototype/c/$companyId/purchases/bills/new'
      preLoaderRoute: typeof PrototypeCCompanyIdPurchasesBillsNewRouteImport
      parentRoute: typeof PrototypeCCompanyIdRoute
    }
    '/prototype/c/$companyId/purchases/bills/$billId': {
      id: '/prototype/c/$companyId/purchases/bills/$billId'
      path: '/purchases/bills/$billId'
      fullPath: '/prototype/c/$companyId/purchases/bills/$billId'
      preLoaderRoute: typeof PrototypeCCompanyIdPurchasesBillsBillIdRouteImport
      parentRoute: typeof PrototypeCCompanyIdRoute
    }
    '/prototype/c/$companyId/banking/easy-entries/new': {
      id: '/prototype/c/$companyId/banking/easy-entries/new'
      path: '/banking/easy-entries/new'
      fullPath: '/prototype/c/$companyId/banking/easy-entries/new'
      preLoaderRoute: typeof PrototypeCCompanyIdBankingEasyEntriesNewRouteImport
      parentRoute: typeof PrototypeCCompanyIdRoute
    }
    '/prototype/c/$companyId/banking/$accountId/reconcile': {
      id: '/prototype/c/$companyId/banking/$accountId/reconcile'
      path: '/banking/$accountId/reconcile'
      fullPath: '/prototype/c/$companyId/banking/$accountId/reconcile'
      preLoaderRoute: typeof PrototypeCCompanyIdBankingAccountIdReconcileRouteImport
      parentRoute: typeof PrototypeCCompanyIdRoute
    }
    '/_auth/c/$companyId/purchases/suppliers/$contactId': {
      id: '/_auth/c/$companyId/purchases/suppliers/$contactId'
      path: '/purchases/suppliers/$contactId'
      fullPath: '/c/$companyId/purchases/suppliers/$contactId'
      preLoaderRoute: typeof AuthCCompanyIdPurchasesSuppliersContactIdRouteImport
      parentRoute: typeof AuthCCompanyIdRoute
    }
    '/_auth/c/$companyId/purchases/payments/new': {
      id: '/_auth/c/$companyId/purchases/payments/new'
      path: '/purchases/payments/new'
      fullPath: '/c/$companyId/purchases/payments/new'
      preLoaderRoute: typeof AuthCCompanyIdPurchasesPaymentsNewRouteImport
      parentRoute: typeof AuthCCompanyIdRoute
    }
    '/_auth/c/$companyId/purchases/payments/$paymentId': {
      id: '/_auth/c/$companyId/purchases/payments/$paymentId'
      path: '/purchases/payments/$paymentId'
      fullPath: '/c/$companyId/purchases/payments/$paymentId'
      preLoaderRoute: typeof AuthCCompanyIdPurchasesPaymentsPaymentIdRouteImport
      parentRoute: typeof AuthCCompanyIdRoute
    }
    '/_auth/c/$companyId/purchases/credits/new': {
      id: '/_auth/c/$companyId/purchases/credits/new'
      path: '/purchases/credits/new'
      fullPath: '/c/$companyId/purchases/credits/new'
      preLoaderRoute: typeof AuthCCompanyIdPurchasesCreditsNewRouteImport
      parentRoute: typeof AuthCCompanyIdRoute
    }
    '/_auth/c/$companyId/purchases/credits/$creditId': {
      id: '/_auth/c/$companyId/purchases/credits/$creditId'
      path: '/purchases/credits/$creditId'
      fullPath: '/c/$companyId/purchases/credits/$creditId'
      preLoaderRoute: typeof AuthCCompanyIdPurchasesCreditsCreditIdRouteImport
      parentRoute: typeof AuthCCompanyIdRoute
    }
    '/_auth/c/$companyId/purchases/bills/new': {
      id: '/_auth/c/$companyId/purchases/bills/new'
      path: '/purchases/bills/new'
      fullPath: '/c/$companyId/purchases/bills/new'
      preLoaderRoute: typeof AuthCCompanyIdPurchasesBillsNewRouteImport
      parentRoute: typeof AuthCCompanyIdRoute
    }
    '/_auth/c/$companyId/purchases/bills/$billId': {
      id: '/_auth/c/$companyId/purchases/bills/$billId'
      path: '/purchases/bills/$billId'
      fullPath: '/c/$companyId/purchases/bills/$billId'
      preLoaderRoute: typeof AuthCCompanyIdPurchasesBillsBillIdRouteImport
      parentRoute: typeof AuthCCompanyIdRoute
    }
    '/_auth/c/$companyId/banking/movements/new': {
      id: '/_auth/c/$companyId/banking/movements/new'
      path: '/banking/movements/new'
      fullPath: '/c/$companyId/banking/movements/new'
      preLoaderRoute: typeof AuthCCompanyIdBankingMovementsNewRouteImport
      parentRoute: typeof AuthCCompanyIdRoute
    }
    '/_auth/c/$companyId/banking/movements/$movementId': {
      id: '/_auth/c/$companyId/banking/movements/$movementId'
      path: '/banking/movements/$movementId'
      fullPath: '/c/$companyId/banking/movements/$movementId'
      preLoaderRoute: typeof AuthCCompanyIdBankingMovementsMovementIdRouteImport
      parentRoute: typeof AuthCCompanyIdRoute
    }
  }
}

interface AuthCCompanyIdRouteChildren {
  AuthCCompanyIdReviewRoute: typeof AuthCCompanyIdReviewRoute
  AuthCCompanyIdSetupRoute: typeof AuthCCompanyIdSetupRoute
  AuthCCompanyIdIndexRoute: typeof AuthCCompanyIdIndexRoute
  AuthCCompanyIdEntriesEntryIdRoute: typeof AuthCCompanyIdEntriesEntryIdRoute
  AuthCCompanyIdJournalsDraftIdRoute: typeof AuthCCompanyIdJournalsDraftIdRoute
  AuthCCompanyIdJournalsNewRoute: typeof AuthCCompanyIdJournalsNewRoute
  AuthCCompanyIdJournalsStockCountRoute: typeof AuthCCompanyIdJournalsStockCountRoute
  AuthCCompanyIdReportsLedgerRoute: typeof AuthCCompanyIdReportsLedgerRoute
  AuthCCompanyIdReportsOpenItemsRoute: typeof AuthCCompanyIdReportsOpenItemsRoute
  AuthCCompanyIdReportsTrialBalanceRoute: typeof AuthCCompanyIdReportsTrialBalanceRoute
  AuthCCompanyIdSettingsApprovalsRoute: typeof AuthCCompanyIdSettingsApprovalsRoute
  AuthCCompanyIdSettingsChartRoute: typeof AuthCCompanyIdSettingsChartRoute
  AuthCCompanyIdSettingsCostCentresRoute: typeof AuthCCompanyIdSettingsCostCentresRoute
  AuthCCompanyIdSettingsDefaultAccountsRoute: typeof AuthCCompanyIdSettingsDefaultAccountsRoute
  AuthCCompanyIdSettingsFxRatesRoute: typeof AuthCCompanyIdSettingsFxRatesRoute
  AuthCCompanyIdSettingsPeriodsRoute: typeof AuthCCompanyIdSettingsPeriodsRoute
  AuthCCompanyIdSettingsUsersRoute: typeof AuthCCompanyIdSettingsUsersRoute
  AuthCCompanyIdBankingIndexRoute: typeof AuthCCompanyIdBankingIndexRoute
  AuthCCompanyIdJournalsIndexRoute: typeof AuthCCompanyIdJournalsIndexRoute
  AuthCCompanyIdBankingMovementsMovementIdRoute: typeof AuthCCompanyIdBankingMovementsMovementIdRoute
  AuthCCompanyIdBankingMovementsNewRoute: typeof AuthCCompanyIdBankingMovementsNewRoute
  AuthCCompanyIdPurchasesBillsBillIdRoute: typeof AuthCCompanyIdPurchasesBillsBillIdRoute
  AuthCCompanyIdPurchasesBillsNewRoute: typeof AuthCCompanyIdPurchasesBillsNewRoute
  AuthCCompanyIdPurchasesCreditsCreditIdRoute: typeof AuthCCompanyIdPurchasesCreditsCreditIdRoute
  AuthCCompanyIdPurchasesCreditsNewRoute: typeof AuthCCompanyIdPurchasesCreditsNewRoute
  AuthCCompanyIdPurchasesPaymentsPaymentIdRoute: typeof AuthCCompanyIdPurchasesPaymentsPaymentIdRoute
  AuthCCompanyIdPurchasesPaymentsNewRoute: typeof AuthCCompanyIdPurchasesPaymentsNewRoute
  AuthCCompanyIdPurchasesSuppliersContactIdRoute: typeof AuthCCompanyIdPurchasesSuppliersContactIdRoute
  AuthCCompanyIdBankingMovementsIndexRoute: typeof AuthCCompanyIdBankingMovementsIndexRoute
  AuthCCompanyIdPurchasesBillsIndexRoute: typeof AuthCCompanyIdPurchasesBillsIndexRoute
  AuthCCompanyIdPurchasesCreditsIndexRoute: typeof AuthCCompanyIdPurchasesCreditsIndexRoute
  AuthCCompanyIdPurchasesPaymentsIndexRoute: typeof AuthCCompanyIdPurchasesPaymentsIndexRoute
  AuthCCompanyIdPurchasesSuppliersIndexRoute: typeof AuthCCompanyIdPurchasesSuppliersIndexRoute
}

const AuthCCompanyIdRouteChildren: AuthCCompanyIdRouteChildren = {
  AuthCCompanyIdReviewRoute: AuthCCompanyIdReviewRoute,
  AuthCCompanyIdSetupRoute: AuthCCompanyIdSetupRoute,
  AuthCCompanyIdIndexRoute: AuthCCompanyIdIndexRoute,
  AuthCCompanyIdEntriesEntryIdRoute: AuthCCompanyIdEntriesEntryIdRoute,
  AuthCCompanyIdJournalsDraftIdRoute: AuthCCompanyIdJournalsDraftIdRoute,
  AuthCCompanyIdJournalsNewRoute: AuthCCompanyIdJournalsNewRoute,
  AuthCCompanyIdJournalsStockCountRoute: AuthCCompanyIdJournalsStockCountRoute,
  AuthCCompanyIdReportsLedgerRoute: AuthCCompanyIdReportsLedgerRoute,
  AuthCCompanyIdReportsOpenItemsRoute: AuthCCompanyIdReportsOpenItemsRoute,
  AuthCCompanyIdReportsTrialBalanceRoute:
    AuthCCompanyIdReportsTrialBalanceRoute,
  AuthCCompanyIdSettingsApprovalsRoute: AuthCCompanyIdSettingsApprovalsRoute,
  AuthCCompanyIdSettingsChartRoute: AuthCCompanyIdSettingsChartRoute,
  AuthCCompanyIdSettingsCostCentresRoute:
    AuthCCompanyIdSettingsCostCentresRoute,
  AuthCCompanyIdSettingsDefaultAccountsRoute:
    AuthCCompanyIdSettingsDefaultAccountsRoute,
  AuthCCompanyIdSettingsFxRatesRoute: AuthCCompanyIdSettingsFxRatesRoute,
  AuthCCompanyIdSettingsPeriodsRoute: AuthCCompanyIdSettingsPeriodsRoute,
  AuthCCompanyIdSettingsUsersRoute: AuthCCompanyIdSettingsUsersRoute,
  AuthCCompanyIdBankingIndexRoute: AuthCCompanyIdBankingIndexRoute,
  AuthCCompanyIdJournalsIndexRoute: AuthCCompanyIdJournalsIndexRoute,
  AuthCCompanyIdBankingMovementsMovementIdRoute:
    AuthCCompanyIdBankingMovementsMovementIdRoute,
  AuthCCompanyIdBankingMovementsNewRoute:
    AuthCCompanyIdBankingMovementsNewRoute,
  AuthCCompanyIdPurchasesBillsBillIdRoute:
    AuthCCompanyIdPurchasesBillsBillIdRoute,
  AuthCCompanyIdPurchasesBillsNewRoute: AuthCCompanyIdPurchasesBillsNewRoute,
  AuthCCompanyIdPurchasesCreditsCreditIdRoute:
    AuthCCompanyIdPurchasesCreditsCreditIdRoute,
  AuthCCompanyIdPurchasesCreditsNewRoute:
    AuthCCompanyIdPurchasesCreditsNewRoute,
  AuthCCompanyIdPurchasesPaymentsPaymentIdRoute:
    AuthCCompanyIdPurchasesPaymentsPaymentIdRoute,
  AuthCCompanyIdPurchasesPaymentsNewRoute:
    AuthCCompanyIdPurchasesPaymentsNewRoute,
  AuthCCompanyIdPurchasesSuppliersContactIdRoute:
    AuthCCompanyIdPurchasesSuppliersContactIdRoute,
  AuthCCompanyIdBankingMovementsIndexRoute:
    AuthCCompanyIdBankingMovementsIndexRoute,
  AuthCCompanyIdPurchasesBillsIndexRoute:
    AuthCCompanyIdPurchasesBillsIndexRoute,
  AuthCCompanyIdPurchasesCreditsIndexRoute:
    AuthCCompanyIdPurchasesCreditsIndexRoute,
  AuthCCompanyIdPurchasesPaymentsIndexRoute:
    AuthCCompanyIdPurchasesPaymentsIndexRoute,
  AuthCCompanyIdPurchasesSuppliersIndexRoute:
    AuthCCompanyIdPurchasesSuppliersIndexRoute,
}

const AuthCCompanyIdRouteWithChildren = AuthCCompanyIdRoute._addFileChildren(
  AuthCCompanyIdRouteChildren,
)

interface AuthRouteChildren {
  AuthNoAccessRoute: typeof AuthNoAccessRoute
  AuthIndexRoute: typeof AuthIndexRoute
  AuthCCompanyIdRoute: typeof AuthCCompanyIdRouteWithChildren
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthNoAccessRoute: AuthNoAccessRoute,
  AuthIndexRoute: AuthIndexRoute,
  AuthCCompanyIdRoute: AuthCCompanyIdRouteWithChildren,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface PrototypeCCompanyIdRouteChildren {
  PrototypeCCompanyIdSplatRoute: typeof PrototypeCCompanyIdSplatRoute
  PrototypeCCompanyIdHomeRoute: typeof PrototypeCCompanyIdHomeRoute
  PrototypeCCompanyIdReviewRoute: typeof PrototypeCCompanyIdReviewRoute
  PrototypeCCompanyIdIndexRoute: typeof PrototypeCCompanyIdIndexRoute
  PrototypeCCompanyIdInboxItemIdRoute: typeof PrototypeCCompanyIdInboxItemIdRoute
  PrototypeCCompanyIdJournalsEntryIdRoute: typeof PrototypeCCompanyIdJournalsEntryIdRoute
  PrototypeCCompanyIdJournalsNewRoute: typeof PrototypeCCompanyIdJournalsNewRoute
  PrototypeCCompanyIdReportsLedgerRoute: typeof PrototypeCCompanyIdReportsLedgerRoute
  PrototypeCCompanyIdReportsTrialBalanceRoute: typeof PrototypeCCompanyIdReportsTrialBalanceRoute
  PrototypeCCompanyIdBankingIndexRoute: typeof PrototypeCCompanyIdBankingIndexRoute
  PrototypeCCompanyIdInboxIndexRoute: typeof PrototypeCCompanyIdInboxIndexRoute
  PrototypeCCompanyIdJournalsIndexRoute: typeof PrototypeCCompanyIdJournalsIndexRoute
  PrototypeCCompanyIdBankingAccountIdReconcileRoute: typeof PrototypeCCompanyIdBankingAccountIdReconcileRoute
  PrototypeCCompanyIdBankingEasyEntriesNewRoute: typeof PrototypeCCompanyIdBankingEasyEntriesNewRoute
  PrototypeCCompanyIdPurchasesBillsBillIdRoute: typeof PrototypeCCompanyIdPurchasesBillsBillIdRoute
  PrototypeCCompanyIdPurchasesBillsNewRoute: typeof PrototypeCCompanyIdPurchasesBillsNewRoute
  PrototypeCCompanyIdPurchasesPaymentsPaymentIdRoute: typeof PrototypeCCompanyIdPurchasesPaymentsPaymentIdRoute
  PrototypeCCompanyIdPurchasesPaymentsNewRoute: typeof PrototypeCCompanyIdPurchasesPaymentsNewRoute
  PrototypeCCompanyIdSalesInvoicesInvoiceIdRoute: typeof PrototypeCCompanyIdSalesInvoicesInvoiceIdRoute
  PrototypeCCompanyIdSalesInvoicesNewRoute: typeof PrototypeCCompanyIdSalesInvoicesNewRoute
  PrototypeCCompanyIdPurchasesBillsIndexRoute: typeof PrototypeCCompanyIdPurchasesBillsIndexRoute
  PrototypeCCompanyIdPurchasesPaymentsIndexRoute: typeof PrototypeCCompanyIdPurchasesPaymentsIndexRoute
  PrototypeCCompanyIdSalesInvoicesIndexRoute: typeof PrototypeCCompanyIdSalesInvoicesIndexRoute
}

const PrototypeCCompanyIdRouteChildren: PrototypeCCompanyIdRouteChildren = {
  PrototypeCCompanyIdSplatRoute: PrototypeCCompanyIdSplatRoute,
  PrototypeCCompanyIdHomeRoute: PrototypeCCompanyIdHomeRoute,
  PrototypeCCompanyIdReviewRoute: PrototypeCCompanyIdReviewRoute,
  PrototypeCCompanyIdIndexRoute: PrototypeCCompanyIdIndexRoute,
  PrototypeCCompanyIdInboxItemIdRoute: PrototypeCCompanyIdInboxItemIdRoute,
  PrototypeCCompanyIdJournalsEntryIdRoute:
    PrototypeCCompanyIdJournalsEntryIdRoute,
  PrototypeCCompanyIdJournalsNewRoute: PrototypeCCompanyIdJournalsNewRoute,
  PrototypeCCompanyIdReportsLedgerRoute: PrototypeCCompanyIdReportsLedgerRoute,
  PrototypeCCompanyIdReportsTrialBalanceRoute:
    PrototypeCCompanyIdReportsTrialBalanceRoute,
  PrototypeCCompanyIdBankingIndexRoute: PrototypeCCompanyIdBankingIndexRoute,
  PrototypeCCompanyIdInboxIndexRoute: PrototypeCCompanyIdInboxIndexRoute,
  PrototypeCCompanyIdJournalsIndexRoute: PrototypeCCompanyIdJournalsIndexRoute,
  PrototypeCCompanyIdBankingAccountIdReconcileRoute:
    PrototypeCCompanyIdBankingAccountIdReconcileRoute,
  PrototypeCCompanyIdBankingEasyEntriesNewRoute:
    PrototypeCCompanyIdBankingEasyEntriesNewRoute,
  PrototypeCCompanyIdPurchasesBillsBillIdRoute:
    PrototypeCCompanyIdPurchasesBillsBillIdRoute,
  PrototypeCCompanyIdPurchasesBillsNewRoute:
    PrototypeCCompanyIdPurchasesBillsNewRoute,
  PrototypeCCompanyIdPurchasesPaymentsPaymentIdRoute:
    PrototypeCCompanyIdPurchasesPaymentsPaymentIdRoute,
  PrototypeCCompanyIdPurchasesPaymentsNewRoute:
    PrototypeCCompanyIdPurchasesPaymentsNewRoute,
  PrototypeCCompanyIdSalesInvoicesInvoiceIdRoute:
    PrototypeCCompanyIdSalesInvoicesInvoiceIdRoute,
  PrototypeCCompanyIdSalesInvoicesNewRoute:
    PrototypeCCompanyIdSalesInvoicesNewRoute,
  PrototypeCCompanyIdPurchasesBillsIndexRoute:
    PrototypeCCompanyIdPurchasesBillsIndexRoute,
  PrototypeCCompanyIdPurchasesPaymentsIndexRoute:
    PrototypeCCompanyIdPurchasesPaymentsIndexRoute,
  PrototypeCCompanyIdSalesInvoicesIndexRoute:
    PrototypeCCompanyIdSalesInvoicesIndexRoute,
}

const PrototypeCCompanyIdRouteWithChildren =
  PrototypeCCompanyIdRoute._addFileChildren(PrototypeCCompanyIdRouteChildren)

interface PrototypeRouteChildren {
  PrototypeIndexRoute: typeof PrototypeIndexRoute
  PrototypeCCompanyIdRoute: typeof PrototypeCCompanyIdRouteWithChildren
}

const PrototypeRouteChildren: PrototypeRouteChildren = {
  PrototypeIndexRoute: PrototypeIndexRoute,
  PrototypeCCompanyIdRoute: PrototypeCCompanyIdRouteWithChildren,
}

const PrototypeRouteWithChildren = PrototypeRoute._addFileChildren(
  PrototypeRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  LoginRoute: LoginRoute,
  PrototypeRoute: PrototypeRouteWithChildren,
  AuthChangePasswordRoute: AuthChangePasswordRoute,
  AuthForgotRoute: AuthForgotRoute,
  AuthInviteRoute: AuthInviteRoute,
  AuthResetRoute: AuthResetRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
